<script>
import resources from './resources'

export default {
  name: 'professional-consultations-made',
  mixins: [resources]
}
</script>

<template lang='pug'>
  .row
    .col-xs-12
      .infos
        .col-xs-6.col-xs-offset-3.col-sm-2.col-sm-offset-0.col-md-offset-0.col-lg-offset-0
          img.img-circle(src='/static/assets/images/paciente-modal.jpg')
        .col-xs-12.col-sm-7.border-right
          .row
            .col-xs-12.col-sm-10
              label.light-red Paciente
              h2.medium-gra João da Silva Santana
            .col-xs-12.col-sm-2
              label.light-red Idade
              h3.medium-gra 38
            .clearfix
            .col-xs-12.col-sm-6
              label.light-red Convênio
              h4.medium-gra Unimed Curitiba
            .col-xs-12.col-sm-6
              label.light-red Empresa
              h4.medium-gra Volvo do Brasil S/A
        .col-xs-12.col-sm-3
          label.light-red Pontualidade
          .time-rating
            span.icon.active 
            span.icon.active 
            span.icon.active 
            span.icon.active 
            span.icon.active 
          label.light-red Comportamento
          .behaviour-rating
            span.icon.active 
            span.icon.active 
            span.icon.active 
            span.icon.active 
            span.icon 
      .clearfix
      .border-top
        .col-xs-12.col-sm-9
          label.light-red Profissional
          h3.medium-gra Dr. Carlos de Carvalho
        .col-xs-12.col-sm-3
          label.light-red CRM
          h3.medium-gra 12345-PR
        .col-xs-12.col-sm-9
          label.light-red Especialidade
          h4.medium-gra Cl&iacute;nica M&eacute;dica
        .col-xs-12.col-sm-3
          label.light-red Hora Marcada
          h4.medium-gra 10h00
      .clearfix
      .border-top.col-xs-12
        label.light-red Hist&oacute;rico de Consultas Realizadas
        .table.col-xs-12
          .row.hidden-xs.hidden-sm
            .col-xs-12.col-sm-2.col-title.text-center Data
            .col-xs-12.col-sm-1.col-title.text-center Hora
            .col-xs-12.col-sm-2.col-title Especialidade
            .col-xs-12.col-sm-3.col-title Profissional
            .col-xs-12.col-sm-2.col-title Status Agenda
            .col-xs-12.col-sm-2.col-title.text-center Receituário
          .order-by.hidden-md.hidden-lg
            span
              select#ordenar-por(name='Ordenar por')
                option(value='Data') Data
                option(value='Hora') Hora
                option(value='Especialidade') Especialidade
                option(value='Profissional') Profissional
                option(value='Status Agenda') Status Agenda
                option(value='Receituário') Receituário
          ul.row
            li
              .col-xs-12.col-sm-2.text-center
                small.grey
                  br
              .col-xs-12.col-sm-1.text-center
                small.grey
                  br
              .col-xs-12.col-sm-2
                small.grey
                  br
              .col-xs-12.col-sm-3
                small.grey
                  br
              .col-xs-12.col-sm-2
                small.grey
                  br
              .col-xs-12.col-sm-2.text-center
                small.grey
                  br
                span.icon.action &#xE921;
              .clearfix
            li
              .col-xs-12.col-sm-2.text-center
                small.grey
                  br
              .col-xs-12.col-sm-1.text-center
                small.grey
                  br
              .col-xs-12.col-sm-2
                small.grey
                  br
              .col-xs-12.col-sm-3
                small.grey
                  br
              .col-xs-12.col-sm-2
                small.grey
                  br
              .col-xs-12.col-sm-2.text-center
                small.grey
                  br
                span.icon.action &#xE921;
              .clearfix
            li
              .col-xs-12.col-sm-2.text-center
                small.grey
                  br
              .col-xs-12.col-sm-1.text-center
                small.grey
                  br
              .col-xs-12.col-sm-2
                small.grey
                  br
              .col-xs-12.col-sm-3
                small.grey
                  br
              .col-xs-12.col-sm-2
                small.grey
                  br
              .col-xs-12.col-sm-2.text-center
                small.grey
                  br
                span.icon.action -
              .clearfix
            li
              .col-xs-12.col-sm-2.text-center
                small.grey
                  br
              .col-xs-12.col-sm-1.text-center
                small.grey
                  br
              .col-xs-12.col-sm-2
                small.grey
                  br
              .col-xs-12.col-sm-3
                small.grey
                  br
              .col-xs-12.col-sm-2
                small.grey
                  br
              .col-xs-12.col-sm-2.text-center
                small.grey
                  br
                span.icon.action &#xE921;
              .clearfix
      .clearfix
      .col-xs-12
        .buttons-wrapper
          button.btn.find-filled
            span.icon 
              | Receituário
          button.btn.find-filled
            span.icon 
              | Atestado Médico
          button.btn.find-filled
            span.icon 
              | Avaliar
          button.btn.find-filled
            span.icon 
              | Encaminhar
          button.btn.cancel-filled.hidden-sm.hidden-md.hidden-lg(data-dismiss='modal')
            span.icon 
              | Fechar
</template>



// WEBPACK FOOTER //
// src/app/employee/dashboard/gadget/components/active-agenda/components/consultations-made/appointment-details.vue